import axios from "../axios";

const getPartners = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('partner/getPartners', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getPartners;
